import { render, staticRenderFns } from "./PlaceGalleryItem.vue?vue&type=template&id=5d6e627e"
import script from "./PlaceGalleryItem.vue?vue&type=script&lang=ts"
export * from "./PlaceGalleryItem.vue?vue&type=script&lang=ts"
import style0 from "./PlaceGalleryItem.vue?vue&type=style&index=0&id=5d6e627e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports